<p *ngIf="dsDropdownLabel" class="ds-dropdown-label"
   [ngClass]="{'small-size': !!smallSize, 'light': !!customDropdown, 'overflow-hidden': !!overflowHidden}"
   >{{dsDropdownLabel}}
  <i class="db-icon db-icon-info-lined ml5" *ngIf="dsDropdownTooltip"
     [dsTooltip]="dsDropdownTooltip"
     dsTooltipSize="small"
     dsTooltipPosition="top"
     dsTooltipAlign="left"></i>
</p>

<a *ngIf="!dsDropdownSearch && !customDropdown" #toggle class="ds-dropdown-selected-option {{color}}"
   [ngClass]="{'ds-dropdown-toggled': toggled, 'disabled': dsDropdownDisabled, 'overflow-hidden': !!overflowHidden}"
   [ngStyle]="{width: dsDropdownWidth, height: dsDropdownHeight}">
  <p [ngClass]="{'flex': !!imgPath, 'overflow-hidden': !!overflowHidden}">
    <img *ngIf="!!imgPath" class="ds-dropdown-img mr10" [src]="imgPath + selectedOption?.value + '.png'"  alt=""/>
    <span [class.small-font]="dsDropdownSmallFont" [class.placeholder]="dsDropdownPlaceholderStyle && dsDropdownPlaceHolder && (selectedOption?.value === '' || selectedOption?.value === null)" [innerHTML]="selectedOption ? selectedOption?.label : dsDropdownPlaceHolder"></span>
  </p>
  <i class="db-icon db-icon-ds-arrow-sharp"></i>
</a>

<a *ngIf="!dsDropdownSearch && !!customDropdown" #toggle class="ds-dropdown-selected-option custom-dropdown {{color}}"
   [ngClass]="{'ds-dropdown-toggled': toggled, 'disabled': dsDropdownDisabled, 'overflow-hidden': !!overflowHidden}">
  <p [ngClass]="{'flex': !!imgPath, 'overflow-hidden': !!overflowHidden}">
    <span [innerHTML]="selectedOption ? selectedOption?.label : dsDropdownPlaceHolder"></span>
  </p>
  <i class="db-icon db-icon-ds-arrow-sharp" *ngIf="!dsDropdownDisabled"></i>
</a>

<div *ngIf="dsDropdownSearch" #toggle class="ds-dropdown-input" [ngClass]="{'ds-dropdown-toggled': toggled, 'disabled': dsDropdownDisabled}">
  <div class="ds-dropdown-selected-option" *ngIf="dsDropdownSelectedInputHolder && !inputFocused && !customDropdown"
       [ngStyle]="{width: dsDropdownWidth, height: dsDropdownHeight}"
       [ngClass]="{'not-valid': !!notValid}"
       (click)="onSelectedOptionClick(searchInput)">
    <img *ngIf="!!imgPath" class="ds-dropdown-img" [src]="imgPath + selectedOption?.value + '.png'"  alt=""/>
    <img *ngIf="selectedOption?.screenshot" [src]="selectedOption?.screenshot" alt="">
    <div>
      <p class="ds-dropdown-option-label" [innerHTML]="selectedOption?.label ? selectedOption?.label : dsDropdownPlaceHolder"></p>
      <p *ngIf="selectedOption?.description"
         class="ds-dropdown-option-desc"
         [innerHTML]="selectedOption?.description"></p>
    </div>
  </div>

  <input #searchInput
         class="ds-dropdown-selected-option" type="text"
         style="font-family: '{{customFontFamily ? selectedOption?.value || dsDropdownPlaceHolder : 'Evergrow Sans'}}', sans-serif;"
         [ngClass]="{'display-none': dsDropdownSelectedInputHolder && !inputFocused,
         'has-selected-value': dsDropdownWithSearchIcon && selectedOption?.label,
         'with-padding': dsDropdownWithSearchIcon && !dsDropdownDisabled}"
         [ngStyle]="{width: dsDropdownWidth, height: dsDropdownHeight}"
         (keydown)="onEnter($event)"
         [formControl]="optionFilter"
         [value]="showDropDown ? selectedOption?.label : selectedOption?.value"
         [placeholder]="dsDropdownPlaceHolder"
         (focusout)="onFocusOut($event)"
         (blur)="inputFocused = false; dsDropdownSelectedInputHolder && searchInput.classList.add('display-none')"
         (focus)="searchInput.select()">
  <i class="db-icon db-icon-ds-search" *ngIf="dsDropdownWithSearchIcon && !dsDropdownDisabled"></i>
  <i class="db-icon db-icon-ds-arrow-sharp" *ngIf="dsDropdownWithArrowIcon && !dsDropdownDisabled"></i>
</div>

<ng-template #templateRef>
  <ul>
    <li *ngFor="let option of filteredOptions">
      <ng-container *ngIf="dsDropdownSimpleList">
        <a class="ds-dropdown-option"
           [class.ds-dropdown-option-disabled]="option?.disabled"
           [ngClass]="{'ds-dropdown-option-selected': option?.value === selectedOption?.value}"
           (click)="selectOption(option)">
          <div>
            <img *ngIf="!!imgPath" class="ds-dropdown-img" [src]="imgPath + option?.value + '.png'"  alt=""/>
            <p class="ds-dropdown-option-label" [innerHTML]="option?.label"></p>
          </div>
        </a>
      </ng-container>
      <ng-container *ngIf="!dsDropdownSimpleList">
        <p *ngIf="option?.optionTitle" class="ds-dropdown-option-list-title" [innerHTML]="option?.optionTitle"></p>
        <a class="ds-dropdown-option" [ngClass]="{'ds-dropdown-option-selected': option?.value === selectedOption?.value,
      'ds-dropdown-option-fully-hovered': dsDropdownFullyHover, 'ds-dropdown-option-disabled': option?.disabled, 'dark':darkMode}"
           (click)="selectOption(option)">
          <img *ngIf="option?.screenshot"
               [src]="(option?.screenshot ?  'data:image/jpg;base64,' + option?.screenshot : '../../../../assets/images/common/no_screenshot.svg')"
               alt=""/>
          <img *ngIf="!!imgPath" class="ds-dropdown-img" [src]="imgPath + option?.value + '.png'"  alt=""/>
          <div>
            <p class="ds-dropdown-option-label"
               style="font-family: '{{customFontFamily ? option?.value : 'Evergrow Sans'}}', sans-serif;"
               [ngClass]="{'ds-dropdown-option-label-bold': option?.description,
                'ds-dropdown-option-label-one-line': dsDropdownOneLine, 'dark':darkMode, 'small-font':dsDropdownSmallFont}"
               [innerHTML]="!showDropDown && option?.highlightedLabel ? option?.highlightedLabel : option?.label">
              <span class="ds-dropdown-option-badge" *ngIf="option.badge">{{option.badge}}</span>
            </p>
            <p *ngIf="option?.description" class="ds-dropdown-option-desc"
               [ngClass]="{'ds-dropdown-option-desc-one-line': dsDropdownOneLine}"
               [innerHTML]="option?.description"></p>
          </div>
        </a>
      </ng-container>

    </li>
  </ul>
</ng-template>

<!-- Usage

<ds-dropdown></ds-dropdown>

attrs:

formControl             - bind form control                                             : formControl
value                   - set initial value                                             : string | number | boolean
dsDropdownOptions       - pass options                                                  : IDsDropdownOption[]
dsDropdownSearch        - dropdown with search mode                                     : boolean
dsDropdownLabel         - label of dropdown                                             : string
dsDropdownPlaceHolder   - placeholder                                                   : string
dsDropdownPosition      - dropdown list position                                        : 'top'|'bottom'
dsDropdownAlign         - dropdown list align                                           : 'left'|'right'
dsDropdownWidth         - width                                                         : string
dsDropdownWidth         - height                                                        : string
dsDropdownListWidth     - dropdown list width                                           : number
dsDropdownListMaxHeight - dropdown list max height                                      : number
onOptionChoose          - returns selected option (use if you don't need form control)  : Function

-->
